import { render, staticRenderFns } from "./lezioni.vue?vue&type=template&id=4c03cf82&"
import script from "./lezioni.vue?vue&type=script&lang=ts&"
export * from "./lezioni.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports